import { voyageGameStatus_enemyShips } from '../voyageGameStatus_enemyShips-sidecar'

export function run_fire() {
  voyageGameStatus_enemyShips.hitByWeapon(0.9, 100, 0, false)
}
